import buildScreenHeaderItems from '@/components/buildScreenHeaderItems'
import OpenInMiniProgram from '@/components/OpenInMiniProgram'
import PillFilterTabs from '@/components/PillFilterTabs'
import StatsGroup from '@/components/StatsGroup'
import CoversByFilter from '@/modules/covers/CoversByFilter'
import useJiriHeaderItems from '@/modules/jiri/useJiriHeaderItems'
import { CoversTagKey } from '@/redux/slices/coverSlice'
import { openCreateFormSheet } from '@/redux/slices/createFormSheetSlice'
import { useAppDispatch, useAppSelector } from '@/redux/store'
import { Stack } from 'expo-router'
import { useState } from 'react'
import { Platform, View } from 'react-native'

const FILTER_TABS: { key: CoversTagKey; label: string }[] = [
  { key: CoversTagKey.RecentlyActive, label: '最近活跃' },
  { key: CoversTagKey.RecentlyCreated, label: '最近创建' },
  { key: CoversTagKey.MyBaseFiles, label: '我的表单' },
  { key: CoversTagKey.Favorates, label: '我的收藏' },
  { key: CoversTagKey.SharedForms, label: '与我共享' },
]

export default function CoversPage() {
  const dispatch = useAppDispatch()
  const jiriHeaderItems = useJiriHeaderItems()
  const currentUserLoaded = useAppSelector(state => state.currentUser.loaded)
  const currentUser = useAppSelector(state => state.currentUser.user)

  const todayStats = useAppSelector(state => state.currentUser.todayStats)
  const [activeTag, setActiveTag] = useState(CoversTagKey.RecentlyActive)

  if (!currentUserLoaded || !currentUser) {
    return null
  }

  const listHeader = (
    <View>
      {Platform.OS !== 'ios' && (
        <View className="mx-4 bg-system-grouped-background rounded-3xl px-4 py-4 mb-4">
          <StatsGroup
            size="medium"
            items={[
              { title: todayStats?.formFillCount ?? 0, description: '今日提交' },
              { title: todayStats?.formViewCount ?? 0, description: '今日浏览' },
            ]}
          />
        </View>
      )}
      <PillFilterTabs tabs={FILTER_TABS} activeTag={activeTag} onSelect={setActiveTag} />
    </View>
  )

  return (
    <>
      <Stack.Screen
        options={{
          ...buildScreenHeaderItems({
            right: [
              {
                type: 'button',
                label: '新建表单',
                variant: 'prominent',
                icon: {
                  name: 'plus',
                  type: 'sfSymbol',
                },
                onPress: () => dispatch(openCreateFormSheet({})),
              },
              ...jiriHeaderItems,
            ],
          }),
        }}
      />
      <CoversByFilter activeTag={activeTag} ListHeaderComponent={listHeader} />
      <OpenInMiniProgram />
    </>
  )
}
